import React, {Component} from 'react';

var PersonalDetailsCol = React.createClass({
    render: function () {
        //console.log(this.props.FieldValue);
        return (
            <div className='PersonalDetailsCol'>
                <div className='FieldName'>
                    {this.props.FieldName}
                </div>
                <div className='FieldValue'>
                    {this.props.FieldValue}
                </div>
            </div>
        )
    }
});

module.exports = {
    PersonalDetailsCol: PersonalDetailsCol
}


// WEBPACK FOOTER //
// ./modules/common/userData.jsx